import Bell from './Index.vue'

Bell.install = function (Vue) {
  Vue.component(Bell.name, Bell)
}

export default Bell
